import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class OutsideProcessContractContingencySupplierService extends Service {
	constructor(injector: Injector) {
		super("OutsideProcessContractContingencySupplier", injector);
	}

	// API
	getByOutsideProcessContractId(outsideProcessContactId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByOutsideProcessContractId/${outsideProcessContactId}`);
	}
}